import React from "react";
import "./GalleryHero.css";
import Navbar from "../Header/Navbar";
import { Link } from "react-router-dom";

const GalleryHero = () => {
  return (
    <>
      <Navbar />

      {/* GALLERY HERO */}
      <section className="gallery-mini-hero">
        <div className="gallery-mini-container">

          {/* Title */}
          <h1 className="gallery-mini-title">Gallery</h1>

          {/* Breadcrumb */}
          <p className="gallery-mini-breadcrumb">
            <Link to="/" className="gallery-mini-link">Home</Link>
            <span>-</span>
            <Link to="/gallery" className="gallery-mini-link">Gallery</Link>
          </p>

        </div>
      </section>

      {/* TAG BELOW HERO */}
     
    </>
  );
};

export default GalleryHero;
